import { jsx as _jsx } from "react/jsx-runtime";
import Relay from './relay.svg';
import DigitalBus from './digitalBus.svg';
import GasBoiler from './gasBoiler.svg';
import ElectricalBoiler from './electricalBoiler.svg';
import ElectrocalWithHWS from './electroWithHWS.svg';
import ElectrocalWithoutHWS from './electroWithoutHWS.svg';
import GasWithHWS from './gasWithHWS.svg';
import GasWithoutHWS from './gasWithoutHWS.svg';
import Single from './single4.svg';
import Double from './double.svg';
import WaterSensor from './waterSensor.svg';
import AirSensor from './airSensor.svg';
import PzaSensor from './pzaSensor.svg';
import WithPID from './withPID.svg';
import WithoutPID from './withoutPID.svg';
import InRoomTemp from './inRoomTemp.svg';
import OutRoomTemp from './outRoomTemp.svg';
import Save from './save.svg';
import DontSave from './dontSave.svg';
import { SettingsMasterStep } from '../../model/type';
import { assertNever } from 'utils';
const style = {
    height: '100%',
    width: '100%',
};
export function getIcon(card_name, path) {
    switch (card_name) {
        case SettingsMasterStep.Relay:
            return _jsx(Relay, { ...style });
        case SettingsMasterStep.DigitalBus:
            return _jsx(DigitalBus, { ...style });
        case SettingsMasterStep.GasBoiler:
            return _jsx(GasBoiler, { ...style });
        case SettingsMasterStep.ElectricalBoiler:
            return _jsx(ElectricalBoiler, { ...style });
        case SettingsMasterStep.BoilerDHW:
            if (path.includes(SettingsMasterStep.ElectricalBoiler)) {
                return _jsx(ElectrocalWithHWS, { ...style });
            }
            else {
                return _jsx(GasWithHWS, { ...style });
            }
        case SettingsMasterStep.BoilerNoDHW:
            if (path.includes(SettingsMasterStep.ElectricalBoiler)) {
                return _jsx(ElectrocalWithoutHWS, { ...style });
            }
            else {
                return _jsx(GasWithoutHWS, { ...style });
            }
        case SettingsMasterStep.SingleCircuit:
            return _jsx(Single, { ...style });
        case SettingsMasterStep.DoubleCircuit:
            return _jsx(Double, { ...style });
        case SettingsMasterStep.AirControl:
            return _jsx(AirSensor, { ...style });
        case SettingsMasterStep.WaterControl:
            return _jsx(WaterSensor, { ...style });
        case SettingsMasterStep.PZAControl:
            return _jsx(PzaSensor, { ...style });
        case SettingsMasterStep.WithoutPIDRegulation:
            return _jsx(WithoutPID, { ...style });
        case SettingsMasterStep.WithPIDRegulation:
            return _jsx(WithPID, { ...style });
        case SettingsMasterStep.InRoomTemp:
            return _jsx(InRoomTemp, { ...style });
        case SettingsMasterStep.OutRoomTemp:
            return _jsx(OutRoomTemp, { ...style });
        case SettingsMasterStep.SavedSetting:
            return _jsx(Save, { ...style });
        case SettingsMasterStep.NoSavedSetting:
            return _jsx(DontSave, { ...style });
        default:
            //@ts-ignore
            return assertNever(card_name);
    }
}
